import React from 'react'

export interface ApolloQueueContextValue {
  processing: boolean
  lastProcess: number
}

export const ApolloQueueContext = React.createContext<ApolloQueueContextValue>({
  processing: false,
  lastProcess: 0
})
